import { useRef, useState } from "react";
import { mdiVolumeOff } from "@mdi/js";
import Icon from "@mdi/react";

type VideoProps = {
	video: string;
}

export default function Video({video}: VideoProps){

	const videoRef = useRef<HTMLVideoElement>(null);
	const [initial, setInitial] = useState(true);
	const [playing, setPlaying] = useState(false);
	const [muted, setMuted] = useState(true);
	const [loop, setLoop] = useState(true);

	function handleClick(){
		setMuted(false);
		setLoop(false);
		if(videoRef.current){
			if(!playing){
				if(initial){
					videoRef.current.currentTime = 0;
				}
				videoRef.current.play();
				setPlaying(true);
				setInitial(false);
			}else{
				videoRef.current.pause();
				setPlaying(false);
			}
		}
	}

	function handleOnEnded(){
		setPlaying(false);
	}

	return (
		<div className="d-flex justify-content-center align-items-center">
			<div className="position-relative" onClick={handleClick}>
				{!playing && (
					<div className="position-absolute rounded-3 d-flex flex-column justify-content-center align-items-center" style={{inset: 0, zIndex: 1, cursor: 'pointer', backgroundColor: "rgba(0,0,0,0.2)"}}>
						<Icon path={mdiVolumeOff} size={4} style={{filter: "drop-shadow(rgba(0, 0, 0, 0.9) 0px 5px 10px)"}}/>
						<div className="text-white fs-1 fw-bold" style={{textShadow: "rgba(0, 0, 0, 0.9) 0px 5px 10px"}}>Clique para ouvir</div>
					</div>
				)}
				<video
					ref={videoRef}
					src={video}
					onEnded={handleOnEnded}
					playsInline
					loop={loop}
					autoPlay={true}
					muted={muted}
					controls={false}
					className={`border border-3 rounded-3 border-primary`}
					style={{maxWidth: "100%", objectFit: "cover", aspectRatio: 16/9, maxHeight: "60vh", cursor: 'pointer', boxShadow: "rgba(191, 148, 86, 0.2) 0px 0px 100px 0px"}}
				/>
			</div>
		</div>
	)
}